import React, { useState } from "react";
import { ChevronLeft, ChevronRight, Star } from "lucide-react";
import { testimonialsIntro, testimonials } from "../mock";

const Testimonials = () => {
  const [idx, setIdx] = useState(0);
  const t = testimonials[idx];
  const prev = () => setIdx((i) => (i - 1 + testimonials.length) % testimonials.length);
  const next = () => setIdx((i) => (i + 1) % testimonials.length);

  return (
    <section id="notes" className="paper py-24" style={{ background: "var(--cream-3)" }}>
      <div className="max-w-[1360px] mx-auto px-6 md:px-10 grid lg:grid-cols-2 gap-14">
        {/* Left */}
        <div>
          <span className="eyebrow">{testimonialsIntro.eyebrow}</span>
          <h2 className="font-display leading-[0.95] mt-6" style={{ color: "var(--wine)" }}>
            <span className="block font-bold" style={{ fontSize: "clamp(2.4rem,5vw,4rem)" }}>{testimonialsIntro.titleTop}</span>
            <span className="block italic font-medium" style={{ fontSize: "clamp(2.4rem,5vw,4rem)" }}>{testimonialsIntro.titleItalic}</span>
          </h2>
          <div className="flex items-center gap-4 mt-10">
            <button onClick={prev} className="w-12 h-12 rounded-full flex items-center justify-center transition-colors duration-300 hover:bg-[var(--wine)] hover:text-[var(--cream)]" style={{ border: "1px solid rgba(89,26,32,0.3)", color: "var(--wine)" }}>
              <ChevronLeft size={20} />
            </button>
            <button onClick={next} className="w-12 h-12 rounded-full flex items-center justify-center transition-colors duration-300 hover:bg-[var(--wine)] hover:text-[var(--cream)]" style={{ border: "1px solid rgba(89,26,32,0.3)", color: "var(--wine)" }}>
              <ChevronRight size={20} />
            </button>
          </div>
        </div>

        {/* Right */}
        <div>
          <div className="w-full h-px mb-8" style={{ background: "rgba(89,26,32,0.2)" }} />
          <div className="flex items-center gap-3 mb-8">
            <div className="flex gap-1">
              {[...Array(5)].map((_, i) => (
                <Star key={`star-${i}`} size={15} fill="var(--gold)" strokeWidth={0} />
              ))}
            </div>
            <span className="font-mono2" style={{ fontSize: "0.68rem", letterSpacing: "0.14em", color: "var(--muted)" }}>{t.rating} / 5</span>
          </div>

          <blockquote key={idx} className="font-display reveal in-view" style={{ color: "var(--wine)", fontSize: "clamp(1.6rem,3vw,2.6rem)", lineHeight: 1.3 }}>
            {"\u201C" + t.quote + "\u201D"}
          </blockquote>

          <div className="flex items-center gap-4 mt-10">
            <div className="w-11 h-11 rounded-full flex items-center justify-center" style={{ background: "var(--rose)", color: "var(--wine)" }}>
              <span className="font-mono2" style={{ fontSize: "0.7rem" }}>{t.initials}</span>
            </div>
            <div>
              <p className="font-mono2" style={{ fontSize: "0.72rem", letterSpacing: "0.14em", color: "var(--wine)" }}>{t.name.toUpperCase()}</p>
              <p className="font-mono2 mt-1" style={{ fontSize: "0.64rem", letterSpacing: "0.14em", color: "var(--muted)" }}>{t.city.toUpperCase()}</p>
            </div>
          </div>

          <div className="flex gap-2 mt-10">
            {testimonials.map((item, i) => (
              <button
                key={item.name}
                onClick={() => setIdx(i)}
                className="h-1 rounded-full transition-all duration-300"
                style={{ width: i === idx ? 40 : 20, background: i === idx ? "var(--wine)" : "rgba(89,26,32,0.25)" }}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
